import React from 'react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/painPoints';
export function PainPointsSection() {
  return <section className="bg-brand-dark px-4 py-16 md:py-24" data-id="element-130" data-mp="2htbopmh5dzgg">
      <Reveal className="mx-auto max-w-[1120px] text-center" data-id="element-131" data-mp="2wpknyo11gcsv">
        <h2 className="text-3xl font-black text-brand-blue md:text-[2.5rem]" data-id="element-132" data-mp="2wmyiqv1me9dt">
          Do You Recognize Yourself in These Situations?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-brand-gray" data-id="element-133" data-mp="35oxxfgp5x1dl">
          If any of these sound familiar, Physical Education Ready was built for your week.
        </p>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-134" data-mp="3ff9cnzeaqwzs">
          {painPoints.map(({
          icon: PointIcon,
          text
        }) => <article key={text} className="flex items-start gap-4 rounded-2xl border border-brand-blue/[0.07] bg-brand-alt p-5 text-left shadow-sm" data-id="element-135" data-mp="3ahr2k5ojmbq7">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-teal/10 text-brand-teal" data-id="element-136" data-mp="3kfnciu5qv0mq">
                <PointIcon className="h-5 w-5" aria-hidden="true" data-id="element-137" data-mp="swkttuckq03k" />
              </span>
              <span className="text-[15px] font-semibold leading-snug" data-id="element-138" data-mp="wwvbi49qaey9">{text}</span>
            </article>)}
        </div>
        <p className="mx-auto mt-10 max-w-2xl font-serif text-2xl font-bold italic text-brand-orange" data-id="element-139" data-mp="11xsrqbb6gyx4">
          You do not need more scattered ideas. You need a complete system.
        </p>
      </Reveal>
    </section>;
}